module.exports = __webpack_public_path__ + "images/emoji/spaghetti.5bd4d75c849a21b9cd71.png";